exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-1f9e7f07]{font-weight:400!important}", ""]);

// exports
